import defaultStatus from '../config/defaultStatus';

const getters = {};

getters.isNotFound = state => state.globalResponseStatus === defaultStatus.NOT_FOUND;
getters.isUnprocessableEntity = state =>
  state.globalResponseStatus === defaultStatus.UNPROCESSABLE_ENTITY;
getters.isAccepted = state => state.globalResponseStatus === defaultStatus.ACCEPTED;
getters.isOk = state => state.globalResponseStatus === defaultStatus.OK;

export default getters;



// WEBPACK FOOTER //
// ./src/screens/Status/store/getters.js